import { helpers, selectors } from 'app-webtech-core';
import { ccMenuReset } from 'app-modules/player/actions';
import { ESC } from './types';

const remoteControllerEscButtonAction = helpers.actions.actionCreator(ESC);

export const remoteControllerEscButtonThunkAction = () => async (dispatch, getState) => {
  await dispatch(remoteControllerEscButtonAction());
  const state = getState();
  const { isCCMenuOpen } = selectors.player.properties(state);

  // checks to see if the cc settings menu is open
  if (isCCMenuOpen) {
    // Resets the setting menu
    dispatch(ccMenuReset());
  }
};
